var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip",class:_vm.item.css_class,on:{"mousemove":_vm.setVisible,"mouseleave":_vm.setInvisible,"click":_vm.toggle}},[_c('transition',{attrs:{"name":"chat-fade"}},[(_vm.isHovering)?_c('div',{staticClass:"tooltip-text",style:({
        backgroundColor: _vm.fairConfig.FC_TOOLTIP_BACKGROUND,
        color: _vm.fairConfig.FC_TOOLTIP_COLOR,
      })},[_vm._v(" "+_vm._s(_vm.item.link)+" ")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }